(function() {
  // --- helpers --------------------------------------------------------------
  function getCardImages(card) {
    const main = card.querySelector('img.grid-product__image') || card.querySelector('.image-wrap img') || card.querySelector('.grid__image-ratio img');
    const secondary = card.querySelector('.grid-product__secondary-image img');
    return { main, secondary };
  }

  function buildSrcset(template, widths) {
    if (!template) return null;
    if (!template.includes('_{width}x.')) {
      template = template.replace(/_([0-9]+)x(\.[^?]+)(\?.*)?$/, '_{width}x$2$3');
    }
    if (template.startsWith('//')) template = location.protocol + template;
    return (widths || []).map(w => template.replace('_{width}x.', `_${w}x.`) + ` ${w}w`).join(', ');
  }

  function applyImage(img, templateOrUrl, variantAlt) {
    if (!img || !templateOrUrl) return;

    // widths from data-widths (e.g. "[180, 360, 540, ...]")
    let widths = [];
    const raw = img.getAttribute('data-widths');
    if (raw) {
      try { widths = JSON.parse(raw); }
      catch(e) { widths = raw.replace(/[\[\]\s]/g,'').split(',').map(Number).filter(Boolean); }
    }

    const srcset = buildSrcset(templateOrUrl, widths) || templateOrUrl;
    const bestW = widths.length ? widths[widths.length - 1] : 600;
    const immediateUrl = templateOrUrl.includes('_{width}x.')
      ? templateOrUrl.replace('_{width}x.', `_${bestW}x.`)
      : templateOrUrl;

    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', srcset);
    img.setAttribute('srcset', srcset);
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', templateOrUrl);

    img.src = immediateUrl;
    img.alt = variantAlt;
    if (img.classList.contains('lazyloaded')) {
      img.classList.remove('lazyloaded');
      img.classList.add('lazyload');
    }
  }

  function updateCardLink(card, variantUrl, variantId) {
    // If the wrapper is an <a>, update its href.
    const anchor = card.querySelector('a.grid-product__link');
    if (anchor && variantUrl) anchor.setAttribute('href', variantUrl);

    // If the wrapper is a <div>, store the URL for JS navigation later.
    const wrapper = !anchor && card.querySelector('.grid-product__link');
    if (wrapper && variantUrl) {
      wrapper.dataset.variantUrl = variantUrl;
      if (variantId) wrapper.dataset.variantId = variantId;
    }

    // If you have a separate title link, update it too (optional).
    const titleLink = card.querySelector('a.grid-product__title-link');
    if (titleLink && variantUrl) titleLink.setAttribute('href', variantUrl);
  }

  // --- behavior -------------------------------------------------------------

  // Swatch CLICK: update images + set target URL to this variant. Do not navigate on swatch.
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.js-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = swatch.dataset.productId;
    const card = document.querySelector(`.grid-product[data-product-id="${productId}"]`);
    if (!card) return;

    const { main, secondary } = getCardImages(card);
    const tplOrUrl = swatch.dataset.variantTemplate || swatch.dataset.variantImage;
    const variantAlt = swatch.dataset.alt || swatch.getAttribute('data-alt');
    applyImage(main, tplOrUrl, variantAlt);
    if (secondary) applyImage(secondary, tplOrUrl, variantAlt);

    const variantUrl = swatch.dataset.href || swatch.getAttribute('data-href') || swatch.getAttribute('href'); // fallback if data-href missing
    const variantId  = swatch.dataset.variantId;
    updateCardLink(card, variantUrl, variantId);

    // Mark swatch active (optional)
    const group = swatch.closest('.grid-product__colors');
    if (group) {
      group.querySelectorAll('.js-swatch[aria-selected="true"]').forEach(el => el.setAttribute('aria-selected', 'false'));
      swatch.setAttribute('aria-selected', 'true');
    }
  });

  // If your wrapper is a <div class="grid-product__link"> (no <a>), make image/title clicks navigate.
  document.addEventListener('click', function(e) {
    const imgClick = e.target.closest('.grid-product__image, .grid__image-ratio img, .image-wrap img');
    const titleClick = e.target.closest('.grid-product__title');
    if (!imgClick && !titleClick) return;

    const card = e.target.closest('.grid-product');
    if (!card) return;

    // If there's an <a>, let the browser handle it.
    if (card.querySelector('a.grid-product__link')) return;

    // Otherwise use the stored data-variant-url on the wrapper <div>.
    const wrapper = card.querySelector('.grid-product__link');
    const url = wrapper && (wrapper.dataset.variantUrl || wrapper.getAttribute('data-variant-url'));
    if (url) window.location.href = url;
  });
})();